/* eslint-disable import/no-unresolved */
import { Helmet } from 'react-helmet-async';
import { useDevice } from 'hooks/useResponsive';

import InspectionPageMobile from './InspectionMobile';
import InspectionPageWeb from './InspectionWeb';

export default function Inspection() {
  const { isMobile } = useDevice();

  return (
    <>
      <Helmet>
        <title>Car Inspection Service | Focus Motors</title>
        <meta name="google-site-verification" content="iOIVKOuZelpVu0rC0hha2Dt6hCT9HyWE4cRqm-Y1y2E" />
        <meta
          name="description"
          content="Looking for a trusted used car inspection service? Focus Motors offers comprehensive car inspection services across Kerala. Our expert technicians thoroughly inspect every vehicle for safety, performance, and reliability before you buy."
        />
        <meta
          name="keywords"
          content="used car inspection, car inspection service, vehicle inspection Kerala, Focus Motors inspection"
        />
        <link rel="canonical" href="https://focusmotors.in/inspection" />
        <meta property="og:title" content="Car Inspection Service | Focus Motors" />
        <meta property="og:description" content="Expert car inspection services at Focus Motors Kerala." />
        <meta property="og:url" content="https://focusmotors.in/inspection" />
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-XF4F99K99B" />
        <script>{`
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'G-XF4F99K99B');
`}</script>
      </Helmet>
      <div>{isMobile ? <InspectionPageMobile /> : <InspectionPageWeb />}</div>
    </>
  );
}
